export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function generateBreadcrumbSchema(items: BreadcrumbItem[], baseUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.href ? `${baseUrl}${item.href}` : undefined,
    })),
  };
}

export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "百合会",
    url: "https://yuriclub.cn",
    description: "百合会是为百合文化爱好者打造的核心聚集地，汇聚百合漫画、百合动漫、百合小说等优质内容与同好交流平台。",
    logo: "https://yuriclub.cn/logo.png",
    sameAs: [
      "https://weibo.com/yuriclub",
      "https://space.bilibili.com/yuriclub",
    ],
  };
}

export function generateWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "百合会",
    url: "https://yuriclub.cn",
    description: "百合会是为百合文化爱好者打造的核心聚集地",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://yuriclub.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };
}